import React, { useEffect, useState, useContext } from 'react'
import { useParams } from 'react-router-dom'
import { Layout } from '../../components/Layout'
import { PodsService } from '../../services/Pods'
import { Context } from '../../Context'
import { GuacamoleService } from '../../services/Guacamole'
import { GLOBALS } from '../../utils/Globals'
import { Message } from 'primereact/message'

import MultiSessionManager from '../../components/RemoteConsoles/MultiSessionManager'

import 'react-tabs/style/react-tabs.css'
import './styles.scss'

export const Pod = () => {
  const { isAuth: token, setPodId, setPodData } = useContext(Context)
  const { id: PodId } = useParams()
  const [error, setError] = useState(null)
  const [Pod, setPod] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [tokens, setTokens] = useState({})

  const config = {
    title: `${Pod.name || ''}`,
    icon: GLOBALS.menu.pods.icon,
    backlink: GLOBALS.menu.pods.link,
  }

  const TransformVirtualMachineRequest = (virtualMachineSelected) => {
    let connectionType
    switch (virtualMachineSelected.connection_type) {
      case 'R':
        connectionType = 'rdp'
        break
      case 'S':
        connectionType = 'ssh'
        break
      case 'V':
        connectionType = 'vnc'
        break
      case 'T':
        connectionType = 'telnet'
        break
      default:
        connectionType = 'ssh'
    }

    return {
      secretKey: 'GvfTBBRdtoPqk4FzxcXrIPxqnRSz0MZH',
      tokenObject: {
        connection: {
          type: connectionType,
          settings: {
            hostname: virtualMachineSelected.ip,
            port: virtualMachineSelected.port,
            username: virtualMachineSelected.username,
            password: virtualMachineSelected.password,
            'enable-drive': true,
            'create-drive-path': true,
            security: 'any',
            'ignore-cert': true,
            'enable-wallpaper': false,
          },
        },
      },
    }
  }

  const fetchData = async () => {
    try {
      setIsLoading(true)
      const pods = await PodsService.getById(PodId, token)
      setPod(pods)
      const tokens = {}

      for (const vm of pods.virtualMachines) {
        const WsUrlGenerated = await GuacamoleService.getEncryptToken(
          TransformVirtualMachineRequest(vm),
          token
        )
        tokens[vm.id] = {
          token: WsUrlGenerated.encryptedToken,
          displayName: vm.display_name,
          resourceType: vm.type,
          host: vm.host_address_pdu,
          load: vm.port_pdu,
        }
      }
      setTokens(tokens)
      setPodData(pods)
    } catch (e) {
      setError(e.message)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    setPodId(PodId)
    fetchData()
  }, [PodId, setPodId])

  return (
    <Layout>
      <>
        {isLoading ? (
          <div className="loading-container">
            <i className="pi pi-spin pi-spinner" style={{ fontSize: '4em' }}></i>
          </div>
        ) : error ? (
          <Message severity="error" text={error}></Message>
        ) : (
          <div className="p-grid rdp-page">
            <div className="p-col-12">
              <div className="card">
                <div className="title-wrap">
                  <h1 className="create-edit-title">
                    {config.icon && <i className={config.icon}></i>}
                    {config.title}
                  </h1>
                </div>
              </div>
            </div>
            <div className="p-col-12">
              <MultiSessionManager ResoucesTokens={tokens} />
            </div>
          </div>
        )}
      </>
    </Layout>
  )
}
